<script lang="ts">
  import { faArrowRight } from '@itdev-fortawesome/pro-solid-svg-icons/faArrowRight';
  import { faLoader } from '@itdev-fortawesome/pro-solid-svg-icons/faLoader';
  import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
  import { onMount } from 'svelte';

  interface Props {
    disabled?: boolean;
    lastBtn?: boolean;
    isSubmitting?: boolean;
  }

  let { disabled, lastBtn, isSubmitting }: Props = $props();

  // approach: two buttons that do the same thing. one is fixed and only appears when the in position button is
  // offscreen, and the other one which stays in position. fixed button not visible at all on md viewports or larger

  let trigger: HTMLDivElement;
  let floatingVisible = $state(false);

  onMount(() => {
    const observer = new IntersectionObserver(entries => {
      floatingVisible = !entries[0].isIntersecting;
    });
    observer.observe(trigger);
    return () => {
      observer.unobserve(trigger);
    };
  });
</script>

<div class="row">
  <div class="col col-md-8 col-lg-6 m-auto d-grid">
    <button type="submit" class="btn btn-primary in-position" {disabled}>
      {#if isSubmitting}
        Submitting... <FontAwesomeIcon icon={faLoader} spin class="ms-1" />
      {:else if lastBtn}
        Finish
      {:else}
        Next <FontAwesomeIcon icon={faArrowRight} class="ms-1" />
      {/if}
    </button>
  </div>
</div>
<div bind:this={trigger}></div>

<div class="bottom-button-background" class:hide={!floatingVisible}>
  <button type="submit" class="btn btn-primary" {disabled}>
    {#if isSubmitting}
      Submitting... <FontAwesomeIcon icon={faLoader} spin class="ms-1" />
    {:else if lastBtn}
      Finish
    {:else}
      Next <FontAwesomeIcon icon={faArrowRight} class="ms-1" />
    {/if}
  </button>
</div>

<style>
  .bottom-button-background {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0.5rem 0.75rem;
    z-index: 99;
    background-color: white;
    border-top: 1px solid var(--bs-secondary-border-subtle);
    box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.15);
    display: grid;
    opacity: 1;
    transition:
      border-color 0.15s ease-in,
      box-shadow 0.15s ease-in-out;
  }

  .bottom-button-background.hide {
    opacity: 0;
    pointer-events: none;
    background-color: transparent;
    border-color: transparent;
    box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0);
  }

  .bottom-button-background.hide button {
    pointer-events: none;
  }

  .in-position {
    margin-bottom: 0.5rem;
  }

  @media (min-width: 768px) {
    .bottom-button-background {
      display: none;
    }
  }
</style>
